export default "__VITE_ASSET__BMSIB46F__"